import { HTMLExtUtils } from '@ssml-editor/core';
import { BREAK_TYPE } from './constant.js';

const breakElementToHtml = ({
  element
}) => {
  const { mark = "", time = "" } = element;
  return HTMLExtUtils.createElementAsString(BREAK_TYPE, true, true, {
    mark,
    time
  });
};

export { breakElementToHtml };
//# sourceMappingURL=element-to-html.js.map
